import React, { useState, useEffect } from "react";
import { CircularProgress, Typography, TextField, Button } from "@mui/material";
import { Wrapper } from "../../styles";
import API from "../../../../axios/instances/API";
import { FEEDBACK_MESSAGES } from "../../../../storage/constants";

const CHARACTER_LIMIT = 58;

const EditStreamName = ({ name, setSnackbarText, mutate, id, readOnly }) => {
  const [prevName, setPrevName] = useState(name);
  const [newName, setNewName] = useState(name);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [charsMaxed, setCharsMaxed] = useState(false);

  useEffect(() => {
    setPrevName(name);
  }, [name]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await API.put("dashboard/streams/details/", {
        id,
        name: newName.trim(),
      });
      setIsSubmitting(false);
      mutate();
      setSnackbarText("Successfully updated stream name success");
    } catch (error) {
      setIsSubmitting(false);
      setSnackbarText(FEEDBACK_MESSAGES.GENERIC_ERROR.concat(" error"));
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const numChars = value?.length || 0;

    const isDeleting = numChars < newName.length;

    if (numChars > CHARACTER_LIMIT && !isDeleting) {
      return setCharsMaxed(true);
    }

    setCharsMaxed(false);
    setNewName(value);
  };

  return (
    <Wrapper style={{ flex: 1 }}>
      <Typography variant="h3">Edit Stream Name</Typography>
      <Typography variant="subtitle1" sx={{ mb: 10 }}>
        You can change your stream name here
      </Typography>
      <TextField
        value={newName}
        onChange={handleChange}
        size="small"
        variant="outlined"
        fullWidth
        label="Stream Name"
        sx={{ mb: 4 }}
        error={charsMaxed}
        helperText={
          charsMaxed && `${CHARACTER_LIMIT} characters maximum for stream name`
        }
      />
      <Button
        color="primary"
        variant="contained"
        fullWidth
        disabled={
          newName.length < 3 || newName === prevName || readOnly || charsMaxed
        }
        startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
        onClick={handleSubmit}
      >
        {isSubmitting ? "Saving..." : "Save Stream Name"}
      </Button>
    </Wrapper>
  );
};

export default EditStreamName;
